<template>
  <v-container fluid
               v-if="template">
    <page-title icon="fas fa-fw fa-envelope">
      {{ template.name }}
      <template v-slot:buttons>
        <v-btn color="primary"
               :to="{name: 'admin.share_template.edit', params: {templateID: templateID}}"
               class="mr-2">
          Edit
        </v-btn>

        <v-btn title="Reload template"
               :disabled="loading"
               @click.prevent="fetchData">
          Refresh
        </v-btn>
      </template>
    </page-title>

    <v-card class="mb-4">
      <v-card-title>
        Subject: {{ template.subject }}
      </v-card-title>
    </v-card>

    <engagement-score-bar :score="engagementScore">
    </engagement-score-bar>

    <v-row v-if="metrics">
      <v-col cols="6"
             md="4">
        <MetricCard title="Delivered"
                    :count="metrics.delivered_count"
                    :rate="Number(metrics.delivered_rate)">
        </MetricCard>
      </v-col>

      <v-col cols="6"
             md="4">
        <MetricCard title="Opened"
                    :count="metrics.unique_open_count"
                    :rate="Number(metrics.open_rate)">
        </MetricCard>
      </v-col>

      <v-col cols="6"
             md="4">
        <MetricCard title="Clicked"
                    :count="metrics.unique_click_count"
                    :rate="Number(metrics.click_rate)">
        </MetricCard>
      </v-col>
    </v-row>

    <v-row v-if="metrics">
      <v-col cols="12"
             md="4">
        <MetricCard title="Unsubscribes"
                    :count="metrics.unique_unsubscribe_count"
                    :rate="Number(metrics.unsubscribe_rate)">
        </MetricCard>
      </v-col>

      <v-col cols="12"
             md="4">
        <MetricCard title="Spam Complaints"
                    :count="metrics.unique_complaint_count"
                    :rate="Number(metrics.complaint_rate)">
        </MetricCard>
      </v-col>

      <v-col cols="12"
             md="4">
        <MetricCard title="Hard Fails"
                    :count="metrics.unique_failed_count"
                    :rate="Number(metrics.failed_rate)">
        </MetricCard>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12">
        <ShareTemplateDailyMetricsChart :template="template"
                                        :start="form.start"
                                        :end="form.end">
          <template v-slot:title>
            Email activity in the past 30 days
          </template>
        </ShareTemplateDailyMetricsChart>
      </v-col>
    </v-row>

    <v-row v-if="template.is_campaign">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Campaigns sent in the past 30 days
            <v-spacer></v-spacer>
            <v-text-field v-model="campaignSearch"
                          append-icon="fal fa-search"
                          small
                          label="Search"
                          single-line
                          hide-details
                          class="pt-0">
            </v-text-field>
            <v-btn v-if="1===2"
                   icon
                   small
                   class="ml-4"
                   @click.prevent="exportCampaigns">
              <v-icon>
                fal fa-fw fa-download
              </v-icon>
            </v-btn>
            <help-dialog v-if="1===2"
                         icon>
            </help-dialog>
          </v-card-title>
          <campaigns-table :loading="loading"
                           :campaigns="campaigns"
                           :search="campaignSearch">
          </campaigns-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Emails sent in the past 30 days
            <v-spacer></v-spacer>
            <v-text-field v-model="messageSearch"
                          append-icon="fal fa-search"
                          small
                          label="Search"
                          single-line
                          hide-details
                          class="pt-0">
            </v-text-field>
            <v-btn v-if="1===2"
                   icon
                   small
                   class="ml-4"
                   @click.prevent="exportMessages">
              <v-icon>
                fal fa-fw fa-download
              </v-icon>
            </v-btn>
            <help-dialog v-if="1===2"
                         icon>
            </help-dialog>
          </v-card-title>
          <v-data-table dense
                        :headers="messageHeaders"
                        :items="messages"
                        :items-per-page="5"
                        :loading="loading"
                        :search="messageSearch">
            <template v-slot:item.recipient="{item: message}">
              {{ message.recipient }}
            </template>
            <template v-slot:item.created_at="{item: message}">
              <message-link :message="message"
                            :use-dialog="true">
              </message-link>
            </template>
            <template v-slot:item.delivered_at="{item:message}">
              <date-tool-tip :date="message.delivered_at">
              </date-tool-tip>
            </template>
            <template v-slot:item.opened_at="{item:message}">
              <date-tool-tip :date="message.opened_at">
              </date-tool-tip>
            </template>
            <template v-slot:item.clicked_at="{item:message}">
              <date-tool-tip :date="message.clicked_at">
              </date-tool-tip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Link activity in the past 30 days
            <v-spacer></v-spacer>
            <v-text-field v-model="linkSearch"
                          append-icon="fal fa-search"
                          small
                          label="Search"
                          single-line
                          hide-details
                          class="pt-0">
            </v-text-field>
            <v-btn v-if="1===2"
                   icon
                   small
                   class="ml-4"
                   @click.prevent="exportLinks">
              <v-icon>
                fal fa-fw fa-download
              </v-icon>
            </v-btn>
            <help-dialog v-if="1===2"
                         icon>
            </help-dialog>
          </v-card-title>
          <v-data-table dense
                        :headers="linkHeaders"
                        :items="links"
                        :items-per-page="5"
                        :loading="loading"
                        :search="linkSearch">
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import {Form} from 'vform';
import shareTemplateService from '../../../../ml/services/shareTemplateService';
import mailcoachService from '../../services/mailcoachService';
import CampaignsTable from '../mailcoach/components/CampaignsTable';
import HelpDialog from '../../components/HelpDialog';
import mailgunService from '../../../../ml/services/mailgunService';
import MessageLink from '../mailgun/components/MessageLink';
import DateToolTip from '../../components/DateToolTip';
import EngagementScoreBar from './components/EngagementScoreBar.vue';
import PageTitle from '../../components/PageTitle.vue';
import moment from 'moment-timezone';
import MetricCard from '../../components/MetricCard.vue';
import ShareTemplateDailyMetricsChart from '../mailgun/components/ShareTemplateDailyMetricsChart.vue';

export default {
  components: {ShareTemplateDailyMetricsChart, MetricCard, PageTitle, EngagementScoreBar, DateToolTip, MessageLink, HelpDialog, CampaignsTable},
  data() {
    return {
      form: new Form({
        start: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      }),
      campaigns: [],
      campaignSearch: null,
      messages: [],
      messageHeaders: [
        {
          text: 'Created',
          value: 'created_at',
        },
        {
          text: 'Sender',
          value: 'sender.name',
        },
        {
          text: 'Recipient',
          value: 'recipient',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Delivered',
          value: 'delivered_at',
        },
        {
          text: 'Opened',
          value: 'opened_at',
        },
        {
          text: 'Clicked',
          value: 'clicked_at',
        },
      ],
      messageSearch: null,
      linkHeaders: [
        {
          text: 'Link',
          value: 'url',
        },
        {
          text: 'Unique clicks',
          value: 'unique_click_count',
        },
        {
          text: 'Total clicks',
          value: 'click_count',
        },
      ],
      links: [],
      linkSearch: null,
      loading: false,
      template: null,
      startAt: moment().subtract(30, 'days').format('YYYY-MM-DD'), // MLD-6049
      deliveries: [],
      opens: [],
      clicks: [],
      failures: [],
      chartHeight: 300,
      chartLoading: false,
      chartOptions: null,
      chartSeries: [],
    }
  },
  computed: {
    ...mapGetters([
      'isEngagementScoreEnabled', // MLD-5526
    ]),
    templateID() {
      return parseInt(this.$route.params.templateID);
    },
    metrics() {
      return this.template.metrics;
    },
    engagementScore() {
      return this.template.metrics.engagement_score;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      return Promise.all([
        this.getTemplate(),
        this.fetchCampaigns(),
        this.getLinks(),
        this.fetchMessages(),
        this.getDailyMetrics(), // MLD-6072
      ])
        .catch(() => {
        })
        .finally(() => {
          this.loading = false;
        })
    },
    async getTemplate() {
      return shareTemplateService.getTemplate(this.templateID)
        .then(data => {
          this.template = data;
        })
        .catch(() => {
        })
    },
    async getLinks() {
      const form = { // MLD-6049
        start_at: this.startAt,
      };
      return shareTemplateService.getLinks(this.templateID, form)
        .then(data => {
          this.links = orderBy(data, ['click_count', 'unique_click_count', 'url'], ['desc', 'desc', 'asc']);
        })
        .catch(() => {
        })
    },
    async fetchCampaigns() {
      const form = {
        share_template_id: this.templateID,
        start_at: this.startAt,
      };
      try {
        let campaigns = await mailcoachService.getCampaigns(form);
        this.campaigns = orderBy(campaigns, ['id'], ['desc']);
      } catch (e) {
      }
    },
    async fetchMessages() {
      const form = {
        share_template_id: this.templateID,
        start_at: this.startAt,
      };
      return mailgunService.fetchMessages(form, 1_000, 3)
        .then(data => {
          this.messages = orderBy(data, ['id'], ['desc']);
        })
        .catch(() => {
        })
    },
    exportCampaigns() {
      const form = {
        share_template_id: this.template.id,
      }
      const filename = `${this.template.name} - campaigns.csv`
      return mailcoachService.exportCampaigns(form, filename);
    },
    async exportLinks() { // MLD-5145
      return shareTemplateService.exportLinks(this.template.id);
    },
    async exportMessages() {
      const form = {
        share_template_id: this.template.id,
        export: 1,
      }
      const filename = `${this.template.name} - emails.csv`;
      return mailgunService.exportMessages(form, filename);
    },
    async getDailyMetrics() { // MLD-6072
      const days = 30;
      this.chartLoading = true;
      // @see https://apexcharts.com/javascript-chart-demos/column-charts/basic/
      await Promise.all([
        shareTemplateService.getDailyMetrics(this.templateID, 'delivered_at', days).then(data => this.deliveries = data),
        shareTemplateService.getDailyMetrics(this.templateID, 'opened_at', days).then(data => this.opens = data),
        shareTemplateService.getDailyMetrics(this.templateID, 'clicked_at', days).then(data => this.clicks = data),
        shareTemplateService.getDailyMetrics(this.templateID, 'failed_at', days).then(data => this.failures = data),
      ])
      this.chartSeries = [];
      this.chartSeries.push({
        name: 'Deliveries',
        data: this.deliveries.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Opens',
        data: this.opens.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Clicks',
        data: this.clicks.map(r => r.value),
      })
      this.chartSeries.push({
        name: 'Failures',
        data: this.failures.map(r => r.value),
      })
      this.chartOptions = {
        chart: {
          toolbar: { // @see https://apexcharts.com/docs/options/chart/toolbar/
            tools: {
              download: false,
              pan: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        xaxis: { // @see https://apexcharts.com/docs/options/xaxis/
          categories: this.deliveries.map(r => r.date),
          labels: {
            rotate: -55,
          },
        }
      }
      this.chartLoading = false;
    }
  },
}
</script>
